import { render, staticRenderFns } from "./operationPromotionStorePromotionAdd.vue?vue&type=template&id=6edd286e&scoped=true"
import script from "./operationPromotionStorePromotionAdd.vue?vue&type=script&lang=js"
export * from "./operationPromotionStorePromotionAdd.vue?vue&type=script&lang=js"
import style0 from "./operationPromotionStorePromotionAdd.vue?vue&type=style&index=0&id=6edd286e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd286e",
  null
  
)

export default component.exports